<template>
  <div>
    <input
      v-model="isChecked"
      @change="toggleFilter()"
      class="checkbox"
      :id="id"
      type="checkbox"
      :disabled="disabled"
      :class="{ disabled: disabled }"
    />
    <label
      :for="id"
      class="checkbox-label"
      :class="{ 'filters__dropdown-label': dropdown, disabled: disabled }"
    >
      <template v-if="this.item.kind==='quick_action'">
        <strong>{{ name }}</strong> - only show me 5 minute actions</template>
      <template v-else-if="this.item.kind==='show_past_events'">
        <strong>{{ name }}</strong></template>
      <template v-else>{{ name }}{{ count }}</template>
    </label>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'Checkbox',
  props: {
    item: Object,
    name: String,
    id: String,
    dropdown: Boolean
  },
  data() {
    return {
      checked: false
    };
  },
  computed: {
    ...mapGetters({
      activeFilters: 'getActiveFilters',
      allIssueFilters: 'getAllIssueFilters',
      facets: 'getFacets',
      initial: 'getInitial',
      newTypeCount: 'getNewTypeCount',
      newArticleTypeCount: 'getNewArticleTypeCount',
      newGroupOneCount: 'getNewGroupOneCount',
      newGroupTwoCount: 'getNewGroupTwoCount',
      newResourceTypeCount: 'getNewResourceTypeCount',
      newIssueCount: 'getNewIssueCount',
      newStateCount: 'getNewStateCount',
      newCampaignCount: 'getNewCampaignCount',
      newGradeLevelCount: 'getNewGradeLevelCount',
      newRoleCount: 'getNewRoleCount',
      newYearCount: 'getNewYearCount',
      newProfessionalPracticeCount: 'getNewProfessionalPracticeCount',
      newFormatCount: 'getNewFormatCount',

      newThemeCount: 'getNewThemeCount',
      newReadingLevelCount: 'getNewReadingLevelCount',
      newGenreCount: 'getNewGenreCount',

      newAcademicSubjectCount: 'getNewAcademicSubjectCount',
      newNEATodayCount: 'getNewNEATodayCount',

      newActionTypeCount: 'getNewActionTypeCount',
      newCongressCount: 'getNewCongressCount',
      newPositionCount: 'getNewPositionCount',
      newChamberCount: 'getNewChamberCount',
      newFederalDepartmentCount: 'getNewFederalDepartmentCount',
      newFederalCommentsYearCount: 'getNewFederalCommentsYearCount',
      newQuickActionCount: 'getNewQuickActionCount',
      newFederalLegislationIssueCount: 'getNewFederalLegislationIssueCount',
      newEventTypeCount: 'getNewEventTypeCount',

      newBusinessItemTypeCount: 'getNewBusinessItemTypeCount',
      newOutcomeCount: 'getNewOutcomeCount',
      newStrategicObjectiveCount: 'getNewStrategicObjectiveCount',

      newNEATodaySectionCount: 'getNewNEATodaySectionCount',
    }),
    isChecked: {
      // getter
      get: function() {
        let set = this.activeFilters.filter(el => {
          return el.name === this.name;
        });
        this.checked = set.length ? true : false;
        return this.checked;
      },
      // setter
      set: function(newValue) {
        this.checked = newValue;
      }
    },
    realResultsCount: function() {
      let kind  =  this.item.kind;

      if (
        this.facets &&
        Object.keys(this.facets).length > 0 &&
        this.facets[kind]
      ) {
        return this.facets[kind][this.item.value] || 0;
      }
    },
    count() {
      let count = '';
      // initial
      if (this.initial && this.realResultsCount) {
        count = this.realResultsCount || '0';
      }
      // group one count
      if (!this.initial && this.item.kind === 'group_one') {
        count = this.newGroupOneCount
          ? this.newGroupOneCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      // article type count
      if (!this.initial && this.item.kind === 'article_type') {
        count = this.newArticleTypeCount
          ? this.newArticleTypeCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      // resource type count
      if (!this.initial && this.item.kind === 'resource_type') {
        count = this.newResourceTypeCount
          ? this.newResourceTypeCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      // format count
      if (!this.initial && this.item.kind === 'session_format') {
        count = this.newFormatCount
          ? this.newFormatCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      // issue count
      if (!this.initial && this.item.kind === 'issue') {
        count = this.newIssueCount
          ? this.newIssueCount[this.item.value] || '0'
          : this.realResultsCount || '0';
        //if both parent and child are selected do not show parent count
        if (this.item.children) {
          for (const [j, child] of Object.entries(this.item.children)) {
            let issue = this.activeFilters.find(
              filter => filter.value === child.value
            );
            if (issue) {
              return '';
            }
          }
        }
      }
      // state count
      if (!this.initial && this.item.kind === 'state') {
        count = this.newStateCount
          ? this.newStateCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      // campaign count
      if (!this.initial && this.item.kind === 'campaign') {
        count = this.newCampaignCount
          ? this.newCampaignCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }

      // Grade level count.
      if (!this.initial && this.item.kind === 'grade_level') {
        count = this.newGradeLevelCount
          ? this.newGradeLevelCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }

      // role count
      if (!this.initial && this.item.kind === 'role') {
        count = this.newRoleCount
          ? this.newRoleCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }

      // year count
      if (!this.initial && this.item.kind === 'year') {
        count = this.newYearCount
          ? this.newYearCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }

      // professional practice count
      if (!this.initial && this.item.kind === 'professional_practice') {
        count = this.newProfessionalPracticeCount
          ? this.newProfessionalPracticeCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      // academic subject count
      if (!this.initial && this.item.kind === 'academic_subject') {
        count = this.newAcademicSubjectCount
          ? this.newAcademicSubjectCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      // nea today count
      if (!this.initial && this.item.kind === 'nea_today') {
        count = this.newNEATodayCount
          ? this.newNEATodayCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }

      // theme count
      if (!this.initial && this.item.kind === 'theme') {
        count = this.newThemeCount
          ? this.newThemeCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      // reading level count
      if (!this.initial && this.item.kind === 'reading_level') {
        count = this.newReadingLevelCount
          ? this.newReadingLevelCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      // genre count
      if (!this.initial && this.item.kind === 'genre') {
        count = this.newGenreCount
          ? this.newGenreCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }

      // action type count
      if (!this.initial && this.item.kind === 'action_type') {
        count = this.newActionTypeCount
          ? this.newActionTypeCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      //  federal legislation issue count
      if (!this.initial && this.item.kind === 'federal_legislation_issue') {
        count = this.newFederalLegislationIssueCount
          ? this.newFederalLegislationIssueCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      // quick action count
      if (!this.initial && this.item.kind === 'quick_action') {
        count = this.newQuickActionCount
          ? this.newQuickActionCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      // position count
      if (!this.initial && this.item.kind === 'position') {
        count = this.newPositionCount
          ? this.newPositionCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      // chamber count
      if (!this.initial && this.item.kind === 'chamber') {
        count = this.newChamberCount
          ? this.newChamberCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      //  Federal Department count
      if (!this.initial && this.item.kind === 'federal_department') {
        count = this.newFederalDepartmentCount
          ? this.newFederalDepartmentCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      // Federal Comments Year count
      if (!this.initial && this.item.kind === 'federal_comments_year') {
        count = this.newFederalCommentsYearCount
          ? this.newFederalCommentsYearCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }
      // congress count
      if (!this.initial && this.item.kind === 'congress') {
        count = this.newCongressCount
          ? this.newCongressCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }


      // event type count
      if (!this.initial && this.item.kind === 'event_type') {
        count = this.newEventTypeCount
          ? this.newEventTypeCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }

      // region count
      if (!this.initial && this.item.kind === 'region') {
        count = this.newRegionCount
          ? this.newRegionCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }

      // business item type count
      if (!this.initial && this.item.kind === 'business_item_type') {
        count = this.newBusinessItemTypeCount
          ? this.newBusinessItemTypeCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }

      // outcome count
      if (!this.initial && this.item.kind === 'outcome') {
        count = this.newOutcomeCount
          ? this.newOutcomeCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }

      // strategic objective count
      if (!this.initial && this.item.kind === 'strategic_objective') {
        count = this.newStrategicObjectiveCount
          ? this.newStrategicObjectiveCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }

      // NEA Today Section count
      if (!this.initial && this.item.kind === 'nea_today_section') {
        count = this.newNEATodaySectionCount
          ? this.newNEATodaySectionCount[this.item.value] || '0'
          : this.realResultsCount || '0';
      }

      return ' (' + count + ')';
    },
    disabled: function() {
      return this.count === ' (0)';
    }
  },
  methods: {
    toggleFilter: function() {
      this.$store.commit('updateCurrentPage', 1);
      let filters = this.activeFilters;
      let allIssueFilters = this.allIssueFilters;
      if (this.checked) {
        filters.push(this.item);
        // if has parent select parent
        if (this.item.parent) {
          // check if parent is already selected
          let set = filters.filter(el => {
            return el.value === this.item.parent.value;
          });
          // if parent is not selected select
          if (set.length === 0) {
            let parent = allIssueFilters[this.item.parent.name];
            filters.push(parent);
          }
        }
      } else {
        // if has children unselect all children
        if (this.item.children) {
          for (const [i, child] of Object.entries(this.item.children)) {
            let index = filters.indexOf(child);
            // if child is selected unselect
            if (index > -1) {
              filters.splice(index, 1); // remove elements starting at given index limit 1
            }
          }
        }
        let index = filters.indexOf(this.item);
        filters.splice(index, 1); // remove elements starting at given index limit 1
      }
      this.$store.commit('updateActiveFilters', filters);
    }
  }
};
</script>

<style scoped>
.filters__dropdown-list:not(:last-child) label {
  margin-bottom: 12px;
}
.filters__dropdown-list:last-child li ul li label {
  margin-top: 12px;
}

.filters__more input.disabled[type='checkbox'] + label {
  color: #00124c;
  opacity: 0.5;
}

.filters__more input.disabled[type='checkbox'] + label::before {
  background: #ffffff;
  border: #ffffff;
  opacity: 1;
}

input.disabled[type='checkbox'] + label::before {
  background: #e3edee;
  border: #e3edee;
  opacity: 0.5;
}

label.disabled {
  cursor: default;
  color: rgba(255, 255, 255, 0.4);
}
</style>
